import { Head } from '@nx-frontend/shared/ui';

export function PageNotFound() {
  return (
    <>
      <Head>
        <title>404 - Page not found</title>
      </Head>
      <div className="flex w-full h-full text-center items-center justify-center">Page not found</div>
    </>
  );
}
